import StoredLayout from '../../layouts/StoredLayout'
import Ionicons from './Ionicons'
export default StoredLayout(Ionicons)



// WEBPACK FOOTER //
// ./src/icons/ionicons/index.js